import { render, staticRenderFns } from "./Setup-Account.vue?vue&type=template&id=792277db&scoped=true&"
import script from "./Setup-Account.vue?vue&type=script&lang=js&"
export * from "./Setup-Account.vue?vue&type=script&lang=js&"
import style0 from "./Setup-Account.vue?vue&type=style&index=0&id=792277db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792277db",
  null
  
)

export default component.exports